import { delayolwo40i9ucjz as delay } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_session9cytjmfbg8nd as get_session,
  get_invalidateAccess2sldhktdow8gg as get_invalidateAccess,
} from '../../../sdk/UserSession.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_selectedContractor2m4vxuqdzv6k3 as get_selectedContractor } from '../../../selectedContractor.mjs';
import { get_pageNavigator1inl9j7ja0vlf as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { ClientDashboard2uxyaz2oxv2st as ClientDashboard } from '../client/ClientDashboard.mjs';
import { ModificationBuilderuhgnvnxpchbi as ModificationBuilder } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ModificationBuilder.mjs';
import { User8yb1tqk4kykg as User } from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { get_membership2p5yrn2d458jx as get_membership } from '../../../../../../crowpay-shared/com/crowpay/UserFields.mjs';
import { PlainTextException3c81a0qh9m2e2 as PlainTextException } from '../../../../../../kiteui-library/com/lightningkite/kiteui/exceptions/handling.mjs';
import { ContractorNewRegistration1u860bdbb1seh as ContractorNewRegistration } from '../auth/NewContractorRegistration.mjs';
import { ContractorDashboardpd20b7ol1l5h as ContractorDashboard } from '../contractor/ContractorDashboard.mjs';
import {
  LogInScreen3qovz4fzwtjwv as LogInScreen,
  AuthScreen1ogng2fnfjgd9 as AuthScreen,
} from '../auth/LogInScreen.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { ActivityIndicatork1oa7i2hevyv as ActivityIndicator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ActivityIndicator.commonHtml.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = delay(500n, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = render$_anonymous_$route$default_2n0uan($this.fj8_1, VOID, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_render$_anonymous_$route__qcjs70($this_frame, tries, $completion) {
  try {
    var tmp = await_0(get_session(), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var session = tmp;
    var tmp_0 = await_0(session.rfw_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var self_0 = tmp_0;
    var membership = self_0.k88_1;
    if (!(membership == null)) {
      var tmp_1 = await_0(session.lfv_1.geo(membership.g8c_1), $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      var contractor = tmp_1;
      if (contractor == null) {
        if (tries > 10)
          throw PlainTextException().lcw("You have a membership to a non-existent contractor. This shouldn't happen, please report this.");
        else if (tries === 1) {
          // Inline function 'com.crowpay.utils.modify2' call
          var this_0 = session.afw_1.geo(session.gfv_1);
          // Inline function 'com.lightningkite.lightningdb.modification' call
          // Inline function 'kotlin.apply' call
          var this_1 = new (ModificationBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_2 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
          var tmp$ret$0 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$0);
          this_1.c44(get_membership(it), null);
          var tmp$ret$5 = this_1.m1r();
          var tmp_3 = this_0.nen(tmp$ret$5, $completion);
          if (tmp_3 === get_COROUTINE_SUSPENDED())
            tmp_3 = yield tmp_3;
        }
        get_invalidateAccess().qaq();
        var tmp_4 = delay(500n, $completion);
        if (tmp_4 === get_COROUTINE_SUSPENDED())
          tmp_4 = yield tmp_4;
        var tmp_5 = render$_anonymous_$route_lovuv0($this_frame, tries + 1 | 0, $completion);
        if (tmp_5 === get_COROUTINE_SUSPENDED())
          tmp_5 = yield tmp_5;
        return Unit_instance;
      }
      var tmp_6 = get_selectedContractor().iah(contractor.t5i_1, $completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
      var tmp_7;
      switch (contractor.r5j_1.b4_1) {
        case 0:
          tmp_7 = new (ContractorNewRegistration())();
          break;
        case 1:
        case 2:
          tmp_7 = new (ContractorDashboard())();
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      var page = tmp_7;
      get_pageNavigator($this_frame).gbw(page);
    } else {
      var tmp_8 = get_selectedContractor().iah(null, $completion);
      if (tmp_8 === get_COROUTINE_SUSPENDED())
        tmp_8 = yield tmp_8;
      get_pageNavigator($this_frame).gbw(new (ClientDashboard())());
    }
  } catch ($p) {
    if ($p instanceof Exception()) {
      var e = $p;
      if (e instanceof PlainTextException())
        throw e;
      get_pageNavigator($this_frame).gbw(new (LogInScreen())());
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function render$_anonymous_$route_lovuv0($this_frame, tries, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_render$_anonymous_$route__qcjs70.bind(VOID, $this_frame, tries), $completion);
}
function render$_anonymous_$route$default_2n0uan($this_frame, tries, $completion, $super) {
  tries = tries === VOID ? 0 : tries;
  return render$_anonymous_$route_lovuv0($this_frame, tries, $completion);
}
var LandingScreen$render$slambdaClass;
function LandingScreen$render$slambda() {
  if (LandingScreen$render$slambdaClass === VOID) {
    class $ {
      constructor($$this$frame) {
        this.fj8_1 = $$this$frame;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LandingScreen$render$slambdaClass = $;
  }
  return LandingScreen$render$slambdaClass;
}
function LandingScreen$render$slambda_0($$this$frame) {
  var i = new (LandingScreen$render$slambda())($$this$frame);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var LandingScreenClass;
function LandingScreen() {
  if (LandingScreenClass === VOID) {
    class $ {
      wd6(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Frame())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        var tmp = view.kbb(get_centered(view), sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_rem(5), get_rem(5)));
        // Inline function 'com.lightningkite.kiteui.views.direct.activityIndicator' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (ActivityIndicator())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view.hbb(p_0, view_0);
        view.lbb(tmp, view_0);
        launch(view, VOID, VOID, LandingScreen$render$slambda_0(view));
        _this__u8e3s4.hbb(p, view);
        return view;
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'LandingScreen', LandingScreen, VOID, [Page(), AuthScreen()], [2]);
    LandingScreenClass = $;
  }
  return LandingScreenClass;
}
//region block: exports
export {
  LandingScreen as LandingScreennv9edtrim3be,
};
//endregion

//# sourceMappingURL=LandingScreen.mjs.map
